import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, MessageSquare, MoreVertical, Trash2 } from 'lucide-react';
import DeleteThreadModal from '../DeleteProjectModal/deleteThreadModal';
import { ThreadCardStyled } from './ThreadCard.styles';

function CardMenu({ onView, onDelete }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div className="menu" ref={ref}>
      <button type="button" className="menu-trigger" onClick={() => setOpen(v => !v)} aria-label="Thread actions">
        <MoreVertical size={16} />
      </button>
      {open && (
        <div className="menu-panel">
          <button
            type="button"
            className="menu-item"
            onClick={() => {
              setOpen(false);
              onView?.();
            }}>
            <Eye size={14} />
            View Chat
          </button>
          <button
            type="button"
            className="menu-item danger"
            onClick={() => {
              setOpen(false);
              onDelete?.();
            }}>
            <Trash2 size={14} />
            Delete Thread
          </button>
        </div>
      )}
    </div>
  );
}

const ThreadCard = ({ threadCardsData, refetch }) => {
  const navigate = useNavigate();
  const [deleteCard, setDeleteCard] = useState(null);

  return (
    <>
      {threadCardsData?.map(card => (
        <ThreadCardStyled key={card?.session_id}>
          <div className="row">
            <button type="button" className="accent" onClick={() => navigate(`/chat/${card?.session_id}`)}>
              <MessageSquare size={20} />
            </button>
            <button type="button" className="body" onClick={() => navigate(`/chat/${card?.session_id}`)}>
              <strong className="title" dangerouslySetInnerHTML={{ __html: card?.title }} />
              <p className="desc" dangerouslySetInnerHTML={{ __html: card?.initial_message }} />
            </button>
            <CardMenu
              onView={() => navigate(`/chat/${card?.session_id}`)}
              onDelete={() => setDeleteCard(card)}
            />
          </div>
          <span className="date">
            Updated: <span dangerouslySetInnerHTML={{ __html: card?.updated_at }} />
          </span>
        </ThreadCardStyled>
      ))}

      {deleteCard && (
        <DeleteThreadModal onClose={() => setDeleteCard(null)} _id={deleteCard?.session_id} refetch={refetch} />
      )}
    </>
  );
};

export default ThreadCard;
